import { useState } from 'react'
import { toast } from 'react-toastify'

import { axiosInstance } from '../helpers'

export interface ApplicantPortalDocument {
    id: number
    name: string
    document_type: string
    document_type_label: string
    status: string
    sent_at: string | null
    completed_at: string | null
    signing_url: string | null
    signed_pdf_url: string | null
    can_sign: boolean
    can_view: boolean
    source?: 'signing' | 'offer' | 'offer_response' | 'application'
}

export const useApplicantDocuments = (leadId: string | null | undefined) => {
    const [isLoading, setIsLoading] = useState(false)
    const [documentList, setDocumentList] = useState<ApplicantPortalDocument[]>(
        [],
    )

    const getDocumentList = async () => {
        if (!leadId) {
            setDocumentList([])
            return []
        }
        setIsLoading(true)
        try {
            const res = await axiosInstance.get<{
                documents: ApplicantPortalDocument[]
            }>(`outreach/leads/${leadId}/documents/`)
            const docs = res.data.documents ?? []
            setDocumentList(docs)
            setIsLoading(false)
            return docs
        } catch (e) {
            toast.error('Error loading documents')
            setIsLoading(false)
            return Promise.reject(e)
        }
    }

    return {
        isLoading,
        documentList,
        getDocumentList,
    }
}
